<!-- @veltra/icons generated sha256:400a1774c63082ac gen:8 source:src/svg/normal/printer.svg -->
<script setup lang="ts">
defineOptions({ name: 'Printer' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M3.999 2.969v1.03h-1c-.556 0-1 .444-1 1v5c0 .556.444 1 1 1h1v1.987c0 .552.45 1.013 1.002 1.013h5.996c.553 0 1.002-.46 1.002-1.013v-1.987h1c.556 0 1-.444 1-1v-5c0-.556-.444-1-1-1h-1v-1.03c0-.552-.45-.97-1.002-.97H5.001c-.553 0-1.002.418-1.002.97m7 1.03h-6v-1h6zm-8 1h10v5h-1v-1.03c0-.552-.45-.97-1.002-.97H5.001c-.553 0-1.002.418-1.002.97v1.03h-1zm2 8v-4h6v4z"
    />
  </svg>
</template>
